import Tippy from "@tippyjs/react";
import { DataTable } from "mantine-datatable";
import { useEffect, useState } from "react";
import { SelectOneDropdown } from "../../../components/custom/select-one-dropdown";
import { IconEdit } from "../../../components/icons/icon-group";
import { dataAppSelected, PAGE_SIZES } from "../../../constants/status";
import { AppVersionResponse } from "../../../models/response/app-version";

interface AppVersionTableProps {
  loadingTable: boolean;
  dataAppVersion: AppVersionResponse[];
  page: number;
  setPage: (value: number) => void;
  limit: number;
  setLimit: (value: number) => void;
  totalRecords: number;

  setOpenModalUpdate: (value: boolean) => void;
  setDataObject: (value: AppVersionResponse) => void;
  setAppType: (value: number) => void;
  setPlatform: (value: number) => void;
}

export const AppVersionTable = (props: AppVersionTableProps) => {
  const [tableMaxHeight, setTableMaxHeight] = useState(0);
  const [selectId, setSelectId] = useState<string>("");

  useEffect(() => {
    if (selectId === "") return;
    const selectIdArray = selectId.split(",");
    const app_type = parseInt(selectIdArray[0], 10);
    const platform = parseInt(selectIdArray[1], 10);
    props.setAppType(app_type);
    props.setPlatform(platform);
  }, [selectId]);

  useEffect(() => {
    const handleResize = () => {
      const header = document.querySelector(".navbar") as HTMLElement;
      if (header) {
        const headerHeight = header.offsetHeight;
        const remainingHeight = window.innerHeight - headerHeight - 150;
        setTableMaxHeight(remainingHeight);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="panel flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <SelectOneDropdown
          selectdId={selectId}
          placeholder="Chọn ứng dụng"
          dataOptions={dataAppSelected}
          getOptionLabel={(option) => option.name}
          getOptionKey={(option) => option.id}
          onChange={(selected) => {
            setSelectId(selected ? selected.id : "");
          }}
        />
      </div>

      <div className="datatables" style={{ height: tableMaxHeight }}>
        <DataTable
          fetching={props.loadingTable}
          withColumnBorders
          noRecordsText="No results match your search query"
          highlightOnHover
          className="whitespace-nowrap table-hover"
          records={props.dataAppVersion}
          columns={[
            {
              accessor: "",
              title: "STT",
              render: (record, index) => <div>{(props.page - 1) * props.limit + index + 1}</div>,
            },
            {
              accessor: "version",
              title: "Phiên bản",
            },
            {
              accessor: "app_type",
              title: "Loại ứng dụng",
              render: (record) => {
                return record.app_type === 1 ? "EMPLOYEE" : "CUSTOMER";
              },
            },
            {
              accessor: "platform",
              title: "Hệ điều hành",
              render: (record) => {
                return record.platform === 1 ? "ANDROID" : "IOS";
              },
            },

            { accessor: "created_at", title: "Ngày tạo" },
            { accessor: "updated_at", title: "Ngày cập nhật" },

            {
              accessor: "action",
              title: "Action",
              titleClassName: "!text-center",
              render: ({ _id }) => {
                const selectedData = props.dataAppVersion.find((item) => item._id === _id) as AppVersionResponse;
                return (
                  <div className="flex items-center w-max mx-auto gap-2">
                    <Tippy content="Chỉnh sửa">
                      <button
                        type="button"
                        onClick={() => {
                          props.setOpenModalUpdate(true);
                          props.setDataObject(selectedData);
                        }}
                      >
                        <IconEdit />
                      </button>
                    </Tippy>
                  </div>
                );
              },
            },
          ]}
          totalRecords={props.totalRecords}
          recordsPerPage={props.limit}
          page={props.page}
          onPageChange={(p) => props.setPage(p)}
          recordsPerPageOptions={PAGE_SIZES}
          onRecordsPerPageChange={props.setLimit}
          minHeight={200}
          paginationText={({ from, to, totalRecords }) => `Hiển thị ${from} đến ${to} của ${totalRecords} hàng`}
        />
      </div>
    </div>
  );
};
